<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title>Creating Excel file</v-card-title>
    <v-row no-gutters>
    </v-row>
    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- <v-btn class="primary mx-2" small @click="saveHsnp">Save</v-btn> -->
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hspt_encrid: null,
      hspt: {},
    }
  },
  methods: {
    open(hspt_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hspt/hsnp/excelExportHsnp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "excelExportHsnp"
          },
          excelExportHsnp: {
            hspt_encrid: hspt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hspt = res.data.excelExportHsnp;
            window.open(this.hspt.filename,'_blank');
            this.dialog = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>

